export const STATIC_FIELD_IDS = {
  SIGNER_EMAIL: '~~SIGNER_EMAIL_FH42JAD8942KDW~~',
  SIGNER_NAME: '~~SIGNER_NAME_JHEK12LKHK12KJ~~',
}

const getStaticFields = (WizardClasses) => {
  const onlyLastNameRequired = process.env.THIRD_PARTY_SIGNATURE_REQUIRE_LAST_NAME_ONLY
  return {
    SIGNER_EMAIL: new WizardClasses.Field({
      businessRules: [
        { fn: 'isValidEmailFormat', props: {} },
        { fn: 'notEmptyOrNull', props: {} },
      ],
      fieldId: STATIC_FIELD_IDS.SIGNER_EMAIL,
      name: 'SIGNER_EMAIL',
      label: "Signer's Email",
      isStaticField: true,
      parent: { type: 'STATIC', id: null },
    }),
    SIGNER_NAME: new WizardClasses.FullName({
      businessRules: [
        {
          fn: 'nameRequired',
          props: { onlyLastNameRequired: onlyLastNameRequired },
        },
      ],
      fieldId: STATIC_FIELD_IDS.SIGNER_NAME,
      name: 'SIGNER_NAME',
      label: "Signer's Name",
      isStaticField: true,
      onlyRequireLastName: onlyLastNameRequired,
      parent: { type: 'STATIC', id: null },
    }),
  }
}

export default getStaticFields
